import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddmaterialdocumentsComponent } from './addmaterialdocuments/addmaterialdocuments.component';
import { AddmaterialsubjectComponent } from './addmaterialsubject/addmaterialsubject.component';
import { AddtopcollegesComponent } from './addtopcolleges/addtopcolleges.component';
import { AddtrendingnewsComponent } from './addtrendingnews/addtrendingnews.component';
import { AuthorisedLayoutComponent } from './layout/authorised/authorised-layout/authorised-layout.component';
// import { MaterialpaymentComponent } from './materialpayment/materialpayment.component';
import { AddCollegeCourseComponent } from './pages/add-college-course/add-college-course.component';
import { AddCollegeImagesComponent } from './pages/add-college-images/add-college-images.component';
import { AddCountryComponent } from './pages/add-country/add-country.component';
import { AddCourseDetailsComponent } from './pages/add-course-details/add-course-details.component';
import { AddCourseTypeComponent } from './pages/add-course-type/add-course-type.component';
import { AddDegreeTypeComponent } from './pages/add-degree-type/add-degree-type.component';
import { AddDegreeComponent } from './pages/add-degree/add-degree.component';
import { AddDistrictComponent } from './pages/add-district/add-district.component';
import { AddStateComponent } from './pages/add-state/add-state.component';
import { AddVideoComponent } from './pages/add-video/add-video.component';
import { AdimagesComponent } from './pages/adimages/adimages.component';
import { AdminUpdateComponent } from './pages/admin-update/admin-update.component';
import { CollegeDetailsComponent } from './pages/college-details/college-details.component';
import { CollegesComponent } from './pages/colleges/colleges.component';
import { CourcesComponent } from './pages/cources/cources.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HomeComponent } from './pages/home/home.component';
import { IndCollegeComponent } from './pages/ind-college/ind-college.component';
import { PaymentsComponent } from './pages/payments/payments.component';
import { ScopeComponent } from './pages/scope/scope.component';
import { SigninComponent } from './pages/signin/signin.component';
import { UserRolesComponent } from './pages/user-roles/user-roles.component';
import { UsersComponent } from './pages/users/users.component';
import { StudymaterialsComponent } from './studymaterials/studymaterials.component';
import { ViewtopadmissionComponent } from './viewtopadmission/viewtopadmission.component';
import { MaterialpaymentComponent } from './materialpayment/materialpayment.component';
import { MaterialsubscriptionComponent } from './materialsubscription/materialsubscription.component';
import { MaterialsyllabusComponent } from './materialsyllabus/materialsyllabus.component';
import { AdvertisementVideoComponent } from './advertisement-video/advertisement-video.component';
import { CoursePaymentsComponent } from './pages/course-payments/course-payments.component';
import { ForeignCollegesComponent } from './foreignCunversity/foreign-colleges.component';
import { ForeignCoursesComponent } from './foreignCourse/foreign-courses.component';
import { ForeignCollegeFeesComponent } from './foreignFees/foreign-college-fees.component';
import { ForeignCollegeImagesComponent } from './foreignImages/foreign-college-images.component';
import { ForeignCollegeVideosComponent } from './foreignVideos/foreign-college-videos.component';
import { OrderCollegeComponent } from './ordercollege/order-college.component';
import { ForeignOrderCollegeComponent } from './foreignOrder/foreign-order-college.component';

// import { OrderCollegeComponent } from './ordercollege/order-college.component';
// import { OrderCollegeComponent } from './ordercollege/order-college.component';
const routes: Routes = [
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'home', component: SigninComponent },
  { path: 'sign-in', component: SigninComponent },
  { path: 'userDetail', component: UsersComponent },
  { path: 'indCollege', component: IndCollegeComponent },

  {
    path: '',
    component: AuthorisedLayoutComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'colleges', component: CollegesComponent },
      { path: 'cources', component: CourcesComponent },
      { path: 'scope', component: ScopeComponent },
      { path: 'addDegree', component: AddDegreeComponent },
      { path: 'addCourseDetails', component: AddCourseDetailsComponent },
      // { path: 'foreign-course', component: ForeignCoursesComponent },
      { path: 'foreign-courses', component: ForeignCoursesComponent },
      { path: 'foreign-university', component: ForeignCollegesComponent },
      { path: 'foreign-college-fees', component: ForeignCollegeFeesComponent },
      {
        path: 'foreign-college-videos',
        component: ForeignCollegeVideosComponent,
      },
      {
        path: 'foreign-college-images',
        component: ForeignCollegeImagesComponent,
      },
      { path: 'collegeDetails', component: CollegeDetailsComponent },
      { path: 'courseType', component: AddCourseTypeComponent },
      { path: 'degreeType', component: AddDegreeTypeComponent },
      { path: 'profile', component: AdminUpdateComponent },
      { path: 'userRoles', component: UserRolesComponent },
      { path: 'adImages', component: AdimagesComponent },
      { path: 'adVideo', component: AddVideoComponent },
      { path: 'addClgImgs', component: AddCollegeImagesComponent },
      { path: 'addCountry', component: AddCountryComponent },
      { path: 'addcourseCollege', component: AddCollegeCourseComponent },
      { path: 'addDistrict', component: AddDistrictComponent },
      { path: 'addState', component: AddStateComponent },
      { path: 'payment', component: PaymentsComponent },
      { path: 'materials', component: StudymaterialsComponent },
      { path: 'materialSubjects', component: AddmaterialsubjectComponent },
      { path: 'materialDocuments', component: AddmaterialdocumentsComponent },
      { path: 'topColleges', component: AddtopcollegesComponent },
      { path: 'trendingNews', component: AddtrendingnewsComponent },
      { path: 'topadmissionform', component: ViewtopadmissionComponent },
      { path: 'materialpayment', component: MaterialpaymentComponent },
      { path: 'materialubscription', component: MaterialsubscriptionComponent },
      { path: 'materialubsyllabus', component: MaterialsyllabusComponent },
      { path: 'dashvideourl', component: AdvertisementVideoComponent },
      { path: 'foreignorder', component: ForeignOrderCollegeComponent },

      { path: 'coursepayment', component: CoursePaymentsComponent },
      // app-routing.module.ts
      // { path: 'order-college', component: OrderCollegeComponent },
      { path: 'order-college', component: OrderCollegeComponent },

      // { path: 'foreign-course', component: ForeignCourseComponent },
      // { path: 'foreign-college-list', component: ForeignCollegeListComponent },
      // { path: 'trendingNews', component: AddtrendingnewsComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
